module.exports = __webpack_public_path__ + "img/panelView_2_3_.2b73223c.png";